import React from "react";
import { Box } from "rebass/styled-components";

export function Menu({ children, ...props }) {
  return (
    <Box variant="menu" {...props}>
      {children}
    </Box>
  );
}
